import { AdminRole, CustomerEditors, ProductEditors, getUserHasRole } from '../../backoffice/dtos/authentication/role';
import { useEffect, useMemo, useState } from "react";
import { Col, Container, Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";
import { user } from "../../backoffice/dtos/authentication/user";
import { getUser } from "../../helpers/localStorage";
import { CustomersSettings } from "../customers/Customers";
import { Products } from "../products/Products";
import User from "../UserInfo/User";
import { Users } from "../users/Users";
import { DepartmentsSettings } from "./SettingPages/Department/DepartmentsSettings";
import { useTranslation } from 'react-i18next';
import AboutPage from './SettingPages/About/AboutPage';

export function Settings() {
    const { t } = useTranslation(['common'])

    const [activePane, setActivePane] = useState("1");
    const user = useMemo(() => {
        return getUser();
    }, [])

    const allowProducts = useMemo(() => {
        if (user === undefined)
            return false;

        return ProductEditors.some(m => getUserHasRole(user, m.name));
    }, [user]);

    const allowCustomers = useMemo(() => {
        if (user === undefined)
            return false;

        return CustomerEditors.some(m => getUserHasRole(user, m.name));
    }, [user]);

    const isAdmin = useMemo(() => {
        if (user === undefined)
            return false;

        return AdminRole.some(m => getUserHasRole(user, m.name));
    }, [user]);

    return (
        <Container className="my-2 flex-fill d-flex flex-column" fluid="lg">
            <Row className="flex-fill">
                <Col md="auto">
                    <Nav vertical pills>
                        <NavItem onClick={() => setActivePane("1")}>
                            <NavLink active={activePane === "1"}>
                                {t("My Account")}
                            </NavLink>
                        </NavItem>
                        <hr />
                        {
                            isAdmin && (
                                <>
                                    <NavItem onClick={() => setActivePane("2")}>
                                        <NavLink active={activePane === "2"}>
                                            {t("Users")}
                                        </NavLink>
                                    </NavItem>
                                </>
                            )
                        }
                        {
                            allowCustomers && (
                                <>
                                    <NavItem onClick={() => setActivePane("5")}>
                                        <NavLink active={activePane === "5"}>
                                            {t("Customers")}
                                        </NavLink>
                                    </NavItem>
                                </>
                            )
                        }
                        {
                            isAdmin && (
                                <>
                                    <NavItem onClick={() => setActivePane("3")}>
                                        <NavLink active={activePane === "3"}>
                                            {t("Departments")}
                                        </NavLink>
                                    </NavItem>
                                </>
                            )
                        }
                        {
                            allowProducts && (
                                <>
                                    <NavItem onClick={() => setActivePane("4")}>
                                        <NavLink active={activePane === "4"}>
                                            {t("Products")}
                                        </NavLink>
                                    </NavItem>
                                </>
                            )
                        }
                        <NavItem onClick={() => setActivePane("6")}>
                            <NavLink active={activePane === "6"}>
                                {t("About")}
                            </NavLink>
                        </NavItem>
                    </Nav>
                </Col>
                <Col md={1} className="d-flex flex-column justify-content-center" style={{ width: "1px" }}>
                    <div style={{
                        borderLeft: "1px solid #aaa",
                        height: "500px",

                    }}></div>
                </Col>
                <Col>
                    <TabContent activeTab={activePane}>
                        <TabPane tabId="1">
                            {activePane === "1" && <User />}
                        </TabPane>
                        {
                            isAdmin && (
                                <>
                                    <TabPane tabId="2">
                                        {activePane === "2" && <Users shown={activePane === "2"} />}
                                    </TabPane>
                                    <TabPane tabId="3">
                                        {activePane === "3" && <DepartmentsSettings shown={activePane === "3"} />}
                                    </TabPane>
                                </>
                            )
                        }
                        {
                            allowProducts && (
                                <>
                                    <TabPane tabId="4">
                                        {activePane === "4" && <Products shown={activePane === "4"} />}
                                    </TabPane>
                                </>
                            )
                        }
                        {
                            allowCustomers && (
                                <>
                                    <TabPane tabId="5">
                                        {activePane === "5" && <CustomersSettings shown={activePane === "5"} isAdmin={isAdmin} />}
                                    </TabPane>
                                </>
                            )
                        }
                        <TabPane tabId="6">
                            {activePane === "6" && <AboutPage isOpen={activePane === "6"} />}
                        </TabPane>
                    </TabContent>
                </Col>
            </Row>
        </Container>
    );
}
